var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignTop = function SvgIconAlignTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 3.75a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 6.5c.966 0 1.75.784 1.75 1.75v8.25A1.75 1.75 0 0 1 18 18.25h-3.375a1.75 1.75 0 0 1-1.75-1.75V8.25c0-.966.784-1.75 1.75-1.75zm-.25 2h-2.875v7.75h2.875zM6 6.5a1.75 1.75 0 0 0-1.75 1.75v12c0 .966.784 1.75 1.75 1.75h3.375a1.75 1.75 0 0 0 1.75-1.75v-12a1.75 1.75 0 0 0-1.75-1.75zM6.25 20V8.5h2.875V20z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconAlignTop;